import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { PartialDocumentsManagementHybridInspections } from "@rightship-tech/document-management-app/views/partials/documents-management-hybrid-inspections/partial-documents-management-hybrid-inspections";
import { autoinject, computedFrom, PLATFORM } from "aurelia-framework";
import { RightShipInspectionDetailsModel } from "../../../models/rightship-inspections.models";
import { RightshipInspectionService } from "../../../services/rightship-inspection.service";
import { VesselModel } from "../../../models/vessel.models";
import { CompanyModel } from "../../../models/company.models";

@autoinject
export class InspectionDocuments {

    public encryptedData: string;
    public rightShipInspectionDetailsModel: RightShipInspectionDetailsModel;
    public vessel: VesselModel;
    public company: CompanyModel; 
    public isLoading: boolean = true;
    public isFallback: boolean;

    constructor(private cacheClientService: CacheClientService, 
        public partialDocumentsManagementHybridInspections: PartialDocumentsManagementHybridInspections,
        private rightShipInspectionService: RightshipInspectionService) {
    }

    @computedFrom("rightShipInspectionDetailsModel")
    get inspectionNumber(): string {
        if(!this.rightShipInspectionDetailsModel) return "";
        const inspectionNumber = this.rightShipInspectionDetailsModel.rightShipInspectionId || "";
        return `INSP #${inspectionNumber}`;
    }

    @computedFrom("rightShipInspectionDetailsModel")
    get location(): string {
        if(!this.rightShipInspectionDetailsModel || !this.rightShipInspectionDetailsModel.portAndOperationalDetails) return "";
        const port = this.rightShipInspectionDetailsModel.portAndOperationalDetails.port || "";
        const country = this.rightShipInspectionDetailsModel.portAndOperationalDetails.country || "";
        return `${country}, ${port}`;
    }

    @computedFrom("inspectionModel")
    get requestedInspectionDate(): string {
        if(!this.rightShipInspectionDetailsModel || !this.rightShipInspectionDetailsModel.portAndOperationalDetails) return "";
        const requestedInspectionDate = this.rightShipInspectionDetailsModel.portAndOperationalDetails.requestedInspectionDate || "";
        return requestedInspectionDate;
    }

    activate(params: { encryptedData: string }) {
        this.encryptedData = decodeURIComponent(params.encryptedData);
    }

    async attached() {

        //Set site name in local storage
        this.cacheClientService.put('site-name', "Inspection Documents", CacheLocation.LocalStorage);

        try {

            //Get RightShip Inspection details
            this.rightShipInspectionDetailsModel = await this.rightShipInspectionService.getRightShipInspectionDetails(this.encryptedData);

            this.vessel = {
                vesselId: this.rightShipInspectionDetailsModel.vesselDetails.vesselId,
                vesselName: this.rightShipInspectionDetailsModel.vesselDetails.vesselName,
                internationalMaritimeOrganizationNumber: this.rightShipInspectionDetailsModel.vesselDetails.vesselImo
            };

             this.company = {
                companyId: this.rightShipInspectionDetailsModel.companyDetails.docCompanyId,
                companyName:this.rightShipInspectionDetailsModel.companyDetails.docCompanyName,
                companyIdentifier: this.rightShipInspectionDetailsModel.companyDetails.docCompanyOwCode
            };

        } catch (error) {
            console.error("Error fetching vessel data", error);
            this.isFallback = true;
        } finally {
            this.isLoading = false;
        }   
    }

    //Get the tooltip view model
    public getTooltipViewModel() {
        const name = PLATFORM.moduleName("views/partials/partial-inspection-layout/partial-tooltip-inspection-details/partial-tooltip-inspection-details");

        return {
            name,
            model: {
                inspectionModel: this.rightShipInspectionDetailsModel
            }
        };
    }
}